import { BadRequestError, UnauthorizedError, APIError, AbortError, NetworkError, } from "../ApiErrors.js";
/**
 * Handle errors from a fetch request
 * @param fn - The fetch function to handle errors for
 * @param fetchArgs - The original fetch arguments to check for abort signal
 * @returns The response from the fetch
 */
export async function errorHandling(fn, fetchArgs) {
    try {
        const response = await fn();
        if (!response.ok) {
            if (response.headers.get("Content-Type")?.includes("application/json")) {
                const errorData = await response.json();
                switch (response.status) {
                    case 400:
                        throw new BadRequestError(errorData?.message, errorData?.stack, response.url, errorData?.detail, errorData?.title, errorData?.instance);
                    case 401:
                        throw new UnauthorizedError(errorData?.detail, errorData?.title, errorData?.instance, response.url);
                    default:
                        throw new APIError(response.url, response.status, errorData);
                }
            }
            const errorText = await response.text();
            throw new APIError(response.url, response.status, errorText);
        }
        return response;
    }
    catch (error) {
        const [url, init] = fetchArgs?.() ?? [];
        // Check if the request was aborted by checking the abort signal
        if (init?.signal?.aborted) {
            throw new AbortError(init.signal.reason);
        }
        if (!(error instanceof BadRequestError) &&
            !(error instanceof UnauthorizedError) &&
            !(error instanceof APIError)) {
            throw new NetworkError("Network error occurred", url?.toString() ?? "unknown", error);
        }
        throw error;
    }
}
